(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-header"]) return;
  try {
    
const mobileMenu=document.querySelector('.b2b-mobile');
if(mobileMenu){
  document.addEventListener('keydown',event=>{
    if(event.key==='Escape'&&mobileMenu.open){mobileMenu.open=false;mobileMenu.querySelector('summary').focus();}
  });
  document.addEventListener('click',event=>{
    if(mobileMenu.open&&!mobileMenu.contains(event.target))mobileMenu.open=false;
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-thermal"] && !Shopify.designMode) return;
  try {
    
const campaignInput=document.getElementById('QuoteCampaign');
if(campaignInput){const parameters=new URLSearchParams(location.search);const campaign={};['utm_source','utm_medium','utm_campaign','utm_content','utm_term'].forEach(key=>{const value=parameters.get(key);if(value)campaign[key]=value.slice(0,200)});campaignInput.value=JSON.stringify(campaign);}
document.querySelectorAll('a[href="#enquiry"]').forEach(link=>link.addEventListener('click',()=>{const model=link.dataset.b2bModel;const selector=document.getElementById('QuoteProduct');if(model&&selector)selector.value=model;document.dispatchEvent(new CustomEvent('b2b:quote_click',{detail:{path:location.pathname}}));}));
if(document.querySelector('[data-b2b-success]'))document.dispatchEvent(new CustomEvent('b2b:quote_success',{detail:{path:location.pathname}}));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
